export const QUERIES = {
  challenges: 'challenges',
  completedChallenges: 'completedChallenges',
};
